import { Alert } from "#/_packages/umbrella/features/alerts/components/alert.tsx";
import { Button } from "#/_packages/umbrella/features/button/components/button.tsx";
import useIsPreviewMode from "#/_packages/umbrella/features/previews/hooks/useIsPreviewMode.ts";
import { clearPreviewCookie } from "#/_packages/umbrella/features/previews/utils/cookie-utils.ts";
import { m } from "#/paraglide/messages";

const removePreviewFromUrl = () => {
	const url = new URL(window.location.href);

	if (url.searchParams.has("preview")) {
		url.searchParams.delete("preview");
	}

	if (url.searchParams.has("rnd")) {
		url.searchParams.delete("rnd");
	}

	if (url.searchParams.has("token")) {
		url.searchParams.delete("token");
	}

	const nextUrl = `${url.pathname}${url.search}${url.hash}`;
	window.location.assign(nextUrl);
};

export default function PagePreviewBanner() {
	const isPreviewMode = useIsPreviewMode();

	const handleDeActivatePreviewMode = async () => {
		await clearPreviewCookie();
		removePreviewFromUrl();
	};

	return isPreviewMode ? (
		<Alert intent={"warning"} className={"rounded-none! "}>
			<div className="flex items-center flex-row justify-between">
				<span className="text-xl font-bold mb-0!">{m.preview_heading()}</span>
				<Button intent={"primary"} onPress={handleDeActivatePreviewMode}>
					{m.preview_deActivePreviewBtnLabel()}
				</Button>
			</div>
		</Alert>
	) : null;
}
